import styled from "styled-components";
import { BadgeProps } from "./types";

/**
 * Estilo do componente Badge
 *
 * Configura estilização dinâmica com base nas props fornecidas.
 */
export const StyledBadge = styled.div.withConfig({
  shouldForwardProp: (prop) => !["backgroundColor"].includes(prop),
})<Pick<BadgeProps, "backgroundColor">>`
  font-size: ${({ theme }) => theme.fontSizes.sm}
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ? theme.colors[backgroundColor] : theme.colors.yellow};
  color: ${({ theme }) => theme.colors.black};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  padding: ${({ theme }) => theme.spacing(0.5)}
    ${({ theme }) => theme.spacing(1.5)};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  position: absolute;
  z-index: 2;
`;
